module.exports = __webpack_public_path__ + "static/media/Element_6_treatments.031884e3.svg";